{{ (groupInfo$ | async)?.name }}{{ isLast ? '' : ',' }}
